<div class="mb-4 w-full">
  @if (label()) {
    <span class="font-medium">{{ label() }}</span>
  }

  <div class="flex flex-col">
    <aura-file-input-preview [control]="control()" [placeholder]="placeholder()" />

    <input
      type="file"
      [accept]="fileAccept()"
      class="hidden"
      (change)="onFileSelected($event)"
      #fileInput
      [attr.aria-label]="label() || 'Choisir un fichier'"
    />

    <!-- Upload button -->
    <div class="flex flex-col">
      <div>
        <button mat-button color="primary" type="button" (click)="fileInput.click()">
          <mat-icon>upload</mat-icon>
          <div class="ml-2 flex flex-col">
            <div>Choisir un fichier</div>
            <i class="text-xs">Taille maximale: {{ maxFileSizeLabel() }} </i>
          </div>
        </button>
      </div>
    </div>
  </div>

  <!-- Error display -->
  @if (control().hasError('required') && control().touched) {
    <div class="mt-1 text-sm text-red">Fichier obligatoire</div>
  }

  @if (control().hasError('fileTooLarge')) {
    <div class="mt-1 text-sm text-red">
      Le fichier dépasse la taille maximale de {{ maxFileSizeLabel() }}.
    </div>
  }
</div>
